import validate from "/home/runner/_work/back-office/back-office/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/_work/back-office/back-office/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  onboarding: () => import("/home/runner/_work/back-office/back-office/apps/back-office/middleware/onboarding.ts"),
  "team-member": () => import("/home/runner/_work/back-office/back-office/apps/back-office/middleware/team-member.ts")
}